<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 6 14">
    <path d="M5.977 3.852c-0.039 0.086-0.125 0.148-0.227 0.148h-1.75v9.75c0 0.141-0.109 0.25-0.25 0.25h-1.5c-0.141 0-0.25-0.109-0.25-0.25v-9.75h-1.75c-0.102 0-0.187-0.055-0.227-0.148s-0.023-0.195 0.039-0.273l2.734-3c0.047-0.047 0.109-0.078 0.18-0.078v0c0.070 0 0.141 0.031 0.187 0.078l2.773 3c0.062 0.078 0.078 0.18 0.039 0.273z"></path>
</svg>
    


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-long-arrow-up.html